import {inlineError} from '@s-ui/decorators/lib'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class CheckPhoneVerificationStatusUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {Repository} deps.userRepository
   */
  constructor({userNotLoggedInUserErrorFactory, userRepository}) {
    super()

    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._userRepository = userRepository
  }

  @inlineError
  async execute({userEntity}) {
    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To check phone verification status the user must be logged in'
        }).toJSON()
      )

    const [error, response] = await this._userRepository.checkPhoneVerificationStatus({
      userEntity
    })

    return error ? Promise.reject(error) : response
  }
}
